import axios from 'axios';
import common from '../common/common';
import sha1 from 'sha1';
axios.defaults.timeout = 100000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
// axios.defaults.baseURL = '/client_web_api';

console.log((new Date()).valueOf())

// 请求拦截
axios.interceptors.request.use(
    config => {
        let nonce = common.getRandomAlphaNum(128);
        let curTime = (new Date()).valueOf();
        let AppSecret = 'fcd6dkhyyvmtbpui4seiggnqjm0bkxlj2rocnoflzw7usq5he9xa8r1zvtaw3p';
        // let AppSecret = 'd6dkhyyvmtbpui4seiggnqjm0bklzw7usq5he9xa8r1zvtaw3p';
        config.headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            nonce: nonce,
            curTime: curTime,
            checkSum: sha1(AppSecret + nonce + curTime)
        };
        return config;
    }, error => {
        Message.error({
            message: '加载超时'
        });
        return Promise.reject(error);
});


export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {params})
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/service/fetch.js